/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { Coordinates } from './Coordinates';
import {
    CoordinatesFromJSON,
    CoordinatesFromJSONTyped,
    CoordinatesToJSON,
    CoordinatesToJSONTyped,
} from './Coordinates';

/**
 * 
 * @export
 * @interface Place
 */
export interface Place {
    /**
     * Unique identifier for the place
     * @type {string}
     * @memberof Place
     */
    readonly id: string;
    /**
     * Mapbox unique identifier for the place
     * @type {string}
     * @memberof Place
     */
    mapboxId: string;
    /**
     * Place name (short form)
     * @type {string}
     * @memberof Place
     */
    name: string;
    /**
     * Full place name with hierarchy
     * @type {string}
     * @memberof Place
     */
    placeName: string;
    /**
     * Mapbox feature type
     * @type {string}
     * @memberof Place
     */
    featureType: PlaceFeatureTypeEnum;
    /**
     * Geographic coordinates of the place
     * @type {Coordinates}
     * @memberof Place
     */
    coordinates: Coordinates;
    /**
     * Traditional address of the place (optional - not all places have addresses)
     * @type {Address}
     * @memberof Place
     */
    address?: Address;
    /**
     * Formatted place context from Mapbox (region, country, postcode)
     * @type {string}
     * @memberof Place
     */
    placeFormatted?: string;
    /**
     * URL of the place image
     * @type {string}
     * @memberof Place
     */
    imageUrl?: string;
    /**
     * POI categories this place belongs to
     * @type {Array<string>}
     * @memberof Place
     */
    poiCategories?: Array<string>;
    /**
     * Canonical POI category IDs
     * @type {Array<string>}
     * @memberof Place
     */
    poiCategoryIds?: Array<string>;
    /**
     * Commercial brand names associated with this POI
     * @type {Array<string>}
     * @memberof Place
     */
    brands?: Array<string>;
    /**
     * Canonical brand IDs
     * @type {Array<string>}
     * @memberof Place
     */
    brandIds?: Array<string>;
    /**
     * Maki icon identifier for this place
     * @type {string}
     * @memberof Place
     */
    maki?: string;
    /**
     * Mapbox relevance score
     * @type {number}
     * @memberof Place
     */
    relevance?: number;
    /**
     * Wikidata identifier
     * @type {string}
     * @memberof Place
     */
    wikidataId?: string;
    /**
     * Timestamp when the place was created
     * @type {Date}
     * @memberof Place
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the place was last updated
     * @type {Date}
     * @memberof Place
     */
    readonly updatedAt: Date;
}


/**
 * @export
 */
export const PlaceFeatureTypeEnum = {
    Country: 'country',
    Region: 'region',
    Postcode: 'postcode',
    District: 'district',
    Place: 'place',
    Locality: 'locality',
    Neighborhood: 'neighborhood',
    Address: 'address',
    Poi: 'poi',
    Category: 'category',
    Street: 'street'
} as const;
export type PlaceFeatureTypeEnum = typeof PlaceFeatureTypeEnum[keyof typeof PlaceFeatureTypeEnum];


/**
 * Check if a given object implements the Place interface.
 */
export function instanceOfPlace(value: object): value is Place {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('mapboxId' in value) || value['mapboxId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('placeName' in value) || value['placeName'] === undefined) return false;
    if (!('featureType' in value) || value['featureType'] === undefined) return false;
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PlaceFromJSON(json: any): Place {
    return PlaceFromJSONTyped(json, false);
}

export function PlaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Place {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'mapboxId': json['mapboxId'],
        'name': json['name'],
        'placeName': json['placeName'],
        'featureType': json['featureType'],
        'coordinates': CoordinatesFromJSON(json['coordinates']),
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'placeFormatted': json['placeFormatted'] == null ? undefined : json['placeFormatted'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'poiCategories': json['poiCategories'] == null ? undefined : json['poiCategories'],
        'poiCategoryIds': json['poiCategoryIds'] == null ? undefined : json['poiCategoryIds'],
        'brands': json['brands'] == null ? undefined : json['brands'],
        'brandIds': json['brandIds'] == null ? undefined : json['brandIds'],
        'maki': json['maki'] == null ? undefined : json['maki'],
        'relevance': json['relevance'] == null ? undefined : json['relevance'],
        'wikidataId': json['wikidataId'] == null ? undefined : json['wikidataId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

  export function PlaceToJSON(json: any): Place {
      return PlaceToJSONTyped(json, false);
  }

  export function PlaceToJSONTyped(value?: Omit<Place, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mapboxId': value['mapboxId'],
        'name': value['name'],
        'placeName': value['placeName'],
        'featureType': value['featureType'],
        'coordinates': CoordinatesToJSON(value['coordinates']),
        'address': AddressToJSON(value['address']),
        'placeFormatted': value['placeFormatted'],
        'imageUrl': value['imageUrl'],
        'poiCategories': value['poiCategories'],
        'poiCategoryIds': value['poiCategoryIds'],
        'brands': value['brands'],
        'brandIds': value['brandIds'],
        'maki': value['maki'],
        'relevance': value['relevance'],
        'wikidataId': value['wikidataId'],
    };
}

